/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum AudioDeviceOutputChannelType {
    /**
     * @deprecated 
     */ 
    DefaultOutputChannel = 3,
    VogOutputChannel = 4,
    VopOutputChannel = 5,
    TrainingRoomOutputChannel = 6,
    VttOutputChannel = 8,
    Exstreamer = 10,
    Websocket = 11,
}
